<template>
  <view-wrapper prefix="Edit" name="Group" path="groups" :loading="loading">
    <wrapper class="mb-5" :checkForChildFocused="true">
      <grafokett-input
        v-if="editGroup"
        :editable="true"
        v-model="editGroup.groupName"
        type="text"
        labelPlaceholder="Group name"
      />
      <div class="my-5 text-right">
        <grafokett-button class="big primary" @click="saveGroupInfo"
          >Save</grafokett-button
        >
      </div>
    </wrapper>

    <wrapper class="mt-5" :focus="true" v-if="groupSettings">
      <h2>Group settings</h2>
      <p v-if="groupSettings.length > 0">Roles</p>
      <div class="flex pt-1">
        <checkbox
          class="flex self-center m-1"
          v-model="groupSettings.allowOrderImportToThisGroup"
        />
        <span class="flex self-center pl-5"
          >Allow order import to this group</span
        >
      </div>
      <div class="flex pt-1">
        <checkbox
          class="flex self-center m-1"
          v-model="groupSettings.useLabelsConnectedToOrdersGroup"
        />
        <span class="flex self-center pl-5"
          >Use Labels connected to orders group</span
        >
      </div>
      <div class="flex pt-1">
        <checkbox
          class="flex self-center m-1"
          v-model="groupSettings.useLabelsConnectedToArticlesGroup"
        />
        <span class="flex self-center pl-5"
          >Use Labels connected to articles</span
        >
      </div>
      <div class="my-5 text-right">
        <grafokett-button class="big primary" @click="saveGroupSettings"
          >Save settings</grafokett-button
        >
      </div>
    </wrapper>

    <AuthorizationZone
      allowAny="AccountType:Administrator,UserRole:ArticleManager"
    >
      <wrapper class="flex flex-col mt-5" :focus="true" v-if="groupSettings">
        <div class="flex items-center w-full" v-if="fileEncodings">
          <drop-down
            class="flex-1 mr-2"
            v-if="fileEncodings.length > 0"
            placeholder="Select file encoding"
            value-property="name"
            :options="fileEncodings"
            v-model="fileEncoding"
          >
          </drop-down>
          <drop-down
            v-if="
              importConfigurations && importConfigurations.length > 0 && isAdmin
            "
            placeholder="Import Configuration"
            value-property="name"
            :options="importConfigurations"
            v-model="importConfiguration"
            class="flex-1"
          ></drop-down>
          <p
            v-if="importConfigurations && importConfigurations.length < 1"
            class="flex-1 ml-4"
          >
            You dont have any import configurations that allows article import
          </p>
        </div>
        <grafokett-button
          :disabled="!importConfiguration"
          class="mt-5 ml-auto big primary"
          @click="exportArticlesForGroup"
          >Export Articles</grafokett-button
        >
      </wrapper>
    </AuthorizationZone>

    <modal type="warning" v-if="errorMessage" @close="errorMessage = null">
      <template slot="body">
        <h2>Error</h2>
        <p>{{ errorMessage }}</p>
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../components/forms/Button.vue";
import GrafokettInput from "../components/forms/Input.vue";
import Wrapper from "../components/Wrapper";
import Checkbox from "../components/forms/Checkbox";
import AuthorizationZone from "../components/AuthorizationZone";
import DropDown from "../components/forms/DropDown.vue";
import Modal from "../components/Modal.vue";
export default {
  components: {
    GrafokettButton,
    GrafokettInput,
    DropDown,
    AuthorizationZone,
    Wrapper,
    Checkbox,
    Modal,
  },
  data() {
    return {
      showDisableBox: false,
      groups: [],
      editGroup: null,
      loading: false,
      fileEncoding: null,
      fileEncodings: [],
      importConfigurations: [],
      importConfiguration: null,
      isAdmin: false,
      errorMessage: null,
    };
  },
  methods: {
    async getData() {
      await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
      this.groups = this.$store.getters["GROUPS/GROUPS"];
      const childGroups = this.groups.flatMap(g => g.children);
      this.editGroup = this.groups
        .concat(childGroups)
        .find(g => g.id == this.$route.params["groupid"]);
      const { data: fileEncodingsData } = await this.$store.$api.get(
        "/api/importconfigurations/encodings"
      );

      const { data } = await this.$store.$api.get("/api/importconfigurations");

      this.importConfigurations =
        data && data.data && data.data.filter(x => !x.usesOrders);

      this.importConfiguration = this.importConfigurations.find(x => x.default);

      this.fileEncodings =
        fileEncodingsData &&
        fileEncodingsData.data &&
        fileEncodingsData.data.map(x => ({ name: x }));
      this.fileEncoding = this.fileEncodings[0];

      const account = this.$store.getters["AUTH/AUTH_GET_USER"];

      this.isAdmin = account.UserRole.includes("Administrator");
    },
    toggleGroupSettings(setting, value) {
      this.editGroup.groupSettings[setting] = value;
    },

    async saveGroupInfo() {
      this.loading = true;

      const payload = {
        ...this.editGroup,
        groupId: this.$route.params["groupid"],
        groupName: this.editGroup.groupName,
      };
      await this.$store.dispatch("GROUPS/SET_GROUP_INFO", payload);
      await this.getData();
      this.loading = false;
    },
    async saveGroupSettings() {
      this.loading = true;

      const payload = {
        ...this.editGroup.groupSettings,
        groupId: this.$route.params["groupid"],
      };
      this.editGroup.groupSettings = null;
      await this.$store.dispatch("GROUPS/SET_GROUP_SETTINGS", payload);
      await this.getData();
      this.loading = false;
    },
    async exportArticlesForGroup() {
      this.loading = true;
      try {
        const payload = {
          groupId: this.$route.params["groupid"],
          fileEncoding: this.fileEncoding && this.fileEncoding.name,
          importConfigurationId: this.importConfiguration.id,
        };

        const res = await this.$store.$api.post(
          "/api/export/articles",
          payload,
          {
            responseType: "blob",
          }
        );

        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(res.data);
        a.download = `Export_${new Date().toISOString().substr(0, 10)}_${
          this.editGroup.groupName
        }`;
        a.click();
        a.remove();
        this.loading = false;
      } catch (error) {
        const message = await error.response.data.text();
        this.errorMessage = message;
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  },
  computed: {
    groupSettings() {
      return this.editGroup && this.editGroup.groupSettings;
    },
    validDelimiters() {
      return ["Semicolon", "Comma", "Tab"];
    },
  },
};
</script>
